import styled from 'styled-components';

const EventItemStyle = styled.div`
	--itemBorderRadius: var(--sp2x);
	--itemImagePaddingTop: 63%;
	--itemContentPadding: var(--sp4x);
	--itemTitleMarginBottom: var(--sp4x);
	--itemDescriptionMarginBottom: var(--sp5x);
	--hashtagWrapMarginBottom: var(--sp6x);
	--hashtagMarginRight: var(--sp2x);
	--eventItemDatePadding: var(--sp2-5x) var(--sp3x);
	--eventItemDateMarginBottom: var(--sp3x);
	--iconSize: var(--sp3x);
	--iconMarginRight: var(--sp1-5x);
	--eventItemDateBorderRadius: var(--sp2x);

	@media (hover: hover) {
		&:hover {
			.event-item-image {
				span {
					img {
						transform: scale(1.3);
					}
				}
			}
		}
	}
	.item-cont {
		display: flex;
		flex-direction: column;
		height: 100%;

		.event-item-image {
			padding-top: var(--itemImagePaddingTop);
			overflow: hidden;
			border-radius: var(--itemBorderRadius) var(--itemBorderRadius) 0 0;
		}

		.item-content {
			display: flex;
			flex-direction: column;
			flex: 1;
			background-color: var(--primaryColor3);
			padding: var(--itemContentPadding);
			border-radius: 0 0 var(--itemBorderRadius) var(--itemBorderRadius);

			.event-item-title {
				margin-bottom: var(--itemTitleMarginBottom);
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
			}

			.event-item-description {
				margin-bottom: var(--itemDescriptionMarginBottom);
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
			}

			.hashtags-wrap {
				display: flex;
				flex-wrap: wrap;
				margin-bottom: var(--hashtagWrapMarginBottom);
				margin-top: auto;

				.hashtag {
					z-index: 1;
					margin-right: var(--hashtagMarginRight);

					&:last-child {
						margin-right: 0;
					}
				}
			}

			.event-item-date {
				display: inline-block;
				align-self: self-start;
				padding: var(--eventItemDatePadding);
				margin-bottom: var(--eventItemDateMarginBottom);
				border-radius: var(--eventItemDateBorderRadius);
				width: fit-content;
			}

			.location-wrap {
				display: flex;

				.location {
					text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;
				}

				.location-icon {
					font-size: var(--iconSize);
					margin-right: var(--iconMarginRight);
				}
			}
		}
	}

	&.similar-events {
		.item-content {
			.hashtags-wrap {
				pointer-events: none;
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--itemContentPadding: var(--sp3x);
		--itemTitleMarginBottom: var(--sp2x);
		--itemDescriptionMarginBottom: var(--sp3x);
		--hashtagWrapMarginBottom: var(--sp5x);
		--hashtagMarginRight: var(--sp2x);
		--eventItemDatePadding: var(--sp1-5x) var(--sp2x);
		--eventItemDateMarginBottom: var(--sp2x);
		--iconSize: var(--sp2x);
		--iconMarginRight: var(--sp1x);
		--eventItemDateBorderRadius: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--itemContentPadding: var(--sp2x);
		--itemTitleMarginBottom: var(--sp2x);
		--itemDescriptionMarginBottom: var(--sp2x);
		--hashtagWrapMarginBottom: var(--sp4x);
		--hashtagMarginRight: var(--sp1-5x);
		--eventItemDatePadding: var(--sp1x) var(--sp1-5x);
		--eventItemDateMarginBottom: var(--sp2x);
		--iconSize: var(--sp2x);
		--iconMarginRight: var(--sp0-5x);
		--eventItemDateBorderRadius: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--itemContentPadding: var(--sp2x);
		--itemTitleMarginBottom: var(--sp2x);
		--itemDescriptionMarginBottom: var(--sp2x);
		--hashtagWrapMarginBottom: var(--sp4x);
		--hashtagMarginRight: var(--sp1-5x);
		--eventItemDatePadding: var(--sp1x) var(--sp1-5x);
		--eventItemDateMarginBottom: var(--sp2x);
		--iconSize: var(--sp2x);
		--iconMarginRight: var(--sp0-5x);
		--eventItemDateBorderRadius: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--itemContentPadding: var(--sp2x);
		--itemTitleMarginBottom: var(--sp2x);
		--itemDescriptionMarginBottom: var(--sp3x);
		--hashtagWrapMarginBottom: var(--sp4x);
		--hashtagMarginRight: var(--sp1-5x);
		--eventItemDatePadding: var(--sp1x) var(--sp1-5x);
		--eventItemDateMarginBottom: var(--sp2x);
		--iconSize: var(--sp2x);
		--iconMarginRight: var(--sp0-5x);
		--eventItemDateBorderRadius: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--itemContentPadding: var(--sp2x);
		--itemTitleMarginBottom: var(--sp2x);
		--itemDescriptionMarginBottom: var(--sp2x);
		--hashtagWrapMarginBottom: var(--sp4x);
		--hashtagMarginRight: var(--sp1-5x);
		--eventItemDatePadding: var(--sp1x) var(--sp1-5x);
		--eventItemDateMarginBottom: var(--sp2x);
		--iconSize: var(--sp2x);
		--iconMarginRight: var(--sp0-5x);
		--eventItemDateBorderRadius: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--itemContentPadding: var(--sp2x);
		--itemTitleMarginBottom: var(--sp2x);
		--itemDescriptionMarginBottom: var(--sp2x);
		--hashtagWrapMarginBottom: var(--sp4x);
		--hashtagMarginRight: var(--sp1-5x);
		--eventItemDatePadding: var(--sp1x) var(--sp1-5x);
		--eventItemDateMarginBottom: var(--sp2x);
		--iconSize: var(--sp2x);
		--iconMarginRight: var(--sp0-5x);
		--eventItemDateBorderRadius: var(--sp1x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--itemContentPadding: var(--sp2x);
		--itemTitleMarginBottom: var(--sp2x);
		--itemDescriptionMarginBottom: var(--sp2x);
		--hashtagWrapMarginBottom: var(--sp4x);
		--hashtagMarginRight: var(--sp1-5x);
		--eventItemDatePadding: var(--sp1x) var(--sp1-5x);
		--eventItemDateMarginBottom: var(--sp2x);
		--iconSize: var(--sp2x);
		--iconMarginRight: var(--sp0-5x);
		--eventItemDateBorderRadius: var(--sp1x);

		margin-bottom: var(--sp2x);

		&:last-child {
			margin-bottom: unset;
		}
	}
`;

export default EventItemStyle;
